/** returns true if value is undefined, null, NaN, '' or []  */
export function isEmpty(value: unknown): boolean {
  if (value === 0) return false;
  if (!value) return true;
  if (typeof value === 'object') {
    if (Array.isArray(value) && value.length === 0) return true;
  }
  return false;
}
